import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import {
  type IInitialFilter,
  type ISearchParameters,
  OPERATOR_SORT,
} from '@features/filters/types';

interface IInitialState {
  searchParameters: ISearchParameters;
  pendingRejectDetailRowId: null | string;
  pendingApproveDetailRowId: null | string;
  prevFilters: Record<string, IInitialFilter>;
  detailsGridSearchParameters: ISearchParameters;
}

export const initialBonusesPendingReviewSearchParameters = {
  page: 1,
  size: 10,
  filters: [],
  sorts: [
    {
      field: 'occurrence_date',
      order: OPERATOR_SORT.DESC,
    },
  ],
};

export const initialBonusesPendingReviewDetailsGridSearchParameters: ISearchParameters =
  {
    page: 1,
    size: 10,
    filters: [],
    sorts: [
      {
        order: OPERATOR_SORT.DESC,
        field: 'given_amount_system',
      },
    ],
  };

const initialState: IInitialState = {
  prevFilters: {},
  pendingRejectDetailRowId: null,
  pendingApproveDetailRowId: null,
  searchParameters: initialBonusesPendingReviewSearchParameters,
  detailsGridSearchParameters:
    initialBonusesPendingReviewDetailsGridSearchParameters,
};

const bonusesPendingReviewSlice = createSlice({
  initialState,
  name: 'bonusesPendingReview',
  reducers: {
    setPrevFilters(
      state: IInitialState,
      action: PayloadAction<Record<string, IInitialFilter>>
    ) {
      state.prevFilters = action.payload;
    },
    setPendingRejectDetailRowId(
      state: IInitialState,
      action: PayloadAction<IInitialState['pendingRejectDetailRowId']>
    ) {
      state.pendingRejectDetailRowId = action.payload;
    },
    setPendingApproveDetailRowId(
      state: IInitialState,
      action: PayloadAction<IInitialState['pendingApproveDetailRowId']>
    ) {
      state.pendingApproveDetailRowId = action.payload;
    },
    setSearchParameters(
      state: IInitialState,
      action: PayloadAction<Partial<ISearchParameters>>
    ) {
      state.searchParameters = { ...state.searchParameters, ...action.payload };
    },
    setDetailsGridSearchParameters(
      state: IInitialState,
      action: PayloadAction<Partial<ISearchParameters>>
    ) {
      state.detailsGridSearchParameters = {
        ...state.detailsGridSearchParameters,
        ...action.payload,
      };
    },
    resetDetailsGridSearchParameters(state: IInitialState) {
      state.detailsGridSearchParameters =
        initialBonusesPendingReviewDetailsGridSearchParameters;
      state.pendingApproveDetailRowId = null;
      state.pendingRejectDetailRowId = null;
    },
  },
});

export default bonusesPendingReviewSlice.reducer;

export const {
  setPrevFilters,
  setSearchParameters,
  setPendingRejectDetailRowId,
  setPendingApproveDetailRowId,
  setDetailsGridSearchParameters,
  resetDetailsGridSearchParameters,
} = bonusesPendingReviewSlice.actions;
